import { render, staticRenderFns } from "./comparative-analysis.vue?vue&type=template&id=10421832&scoped=true"
import script from "./comparative-analysis.vue?vue&type=script&lang=js"
export * from "./comparative-analysis.vue?vue&type=script&lang=js"
import style0 from "./comparative-analysis.vue?vue&type=style&index=0&id=10421832&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10421832",
  null
  
)

export default component.exports